import { render, staticRenderFns } from "./EventSection.vue?vue&type=template&id=472079e3"
import script from "./EventSection.vue?vue&type=script&lang=js"
export * from "./EventSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports